/* tslint:disable */
/* eslint-disable */
/**
 * compass-pro
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface DeleteEmergencyConfigRequest
 */
export interface DeleteEmergencyConfigRequest {
    /**
     * 
     * @type {string}
     * @memberof DeleteEmergencyConfigRequest
     */
    org_code: string;
    /**
     * 
     * @type {string}
     * @memberof DeleteEmergencyConfigRequest
     */
    config_id: string;
}

/**
 * Check if a given object implements the DeleteEmergencyConfigRequest interface.
 */
export function instanceOfDeleteEmergencyConfigRequest(value: object): value is DeleteEmergencyConfigRequest {
    if (!('org_code' in value) || value['org_code'] === undefined) return false;
    if (!('config_id' in value) || value['config_id'] === undefined) return false;
    return true;
}

export function DeleteEmergencyConfigRequestFromJSON(json: any): DeleteEmergencyConfigRequest {
    return DeleteEmergencyConfigRequestFromJSONTyped(json, false);
}

export function DeleteEmergencyConfigRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): DeleteEmergencyConfigRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'org_code': json['org_code'],
        'config_id': json['config_id'],
    };
}

export function DeleteEmergencyConfigRequestToJSON(json: any): DeleteEmergencyConfigRequest {
    return DeleteEmergencyConfigRequestToJSONTyped(json, false);
}

export function DeleteEmergencyConfigRequestToJSONTyped(value?: DeleteEmergencyConfigRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'org_code': value['org_code'],
        'config_id': value['config_id'],
    };
}

